import { media } from 'consumer-components';

const PaneLayoutConstants = Object.freeze({
  splitContentStaticWidthMixin: {
    maxWidth: 520,
    width: '100%',
    [media.mobileMedium]: {
      width: '100%',
    },
  },
});

export default PaneLayoutConstants;
